import React, { useContext, useEffect, useState } from 'react';

import { Link as RouterLink } from 'react-router-dom';

import {
    Button,
    Card,
    CardContent,
    CardHeader, Divider, Grid, IconButton, Link, Table,
    TableBody, TableCell, TableHead, TablePagination, TableRow, Tooltip, Typography
} from '@mui/material';

import DeleteIcon from '@mui/icons-material/Delete';

import { stringToLocaleDateString } from '../../../../helpers';
import { UtenteLink } from '../../../common';
import { NavContext } from "../../../contexts";
import { ComuneCompetenzaContext } from '../ComuneCompetenzaContext';

const LinkRouter = props => <Link {...props} component={RouterLink} />;

export const EccezioniList = ({
    searchText,
    itemsPerPage,
    disabled,
    onLoadMore,
    onActionClick,
    ...props }) => {

    const {
        getRouteTo
    } = useContext(NavContext);

    const {
        state,
    } = useContext(ComuneCompetenzaContext);

    const {
        eccezioni
    } = state;

    const [pageIndex, setPageIndex] = useState(0);
    const pageIndexChangeHandler = (e, index) => {
        setPageIndex(index);
    }

    const [pageSize, setPageSize] = useState(itemsPerPage);
    const pageSizeChangeHandler = (e) => {
        setPageSize(e.target.value)
    }

    const deleteClickHandler = async (data) => {
        if (onActionClick)
            onActionClick("Delete", data);
    }

    const addClickHandler = (data) => {
        if (onActionClick)
            onActionClick("Add", data);
    }

    useEffect(() => {
        if (eccezioni && onLoadMore) {
            onLoadMore(searchText, pageIndex, pageSize);
        }
    }, [pageIndex, pageSize]);

    useEffect(() => {
        if (eccezioni && onLoadMore) {
            onLoadMore(searchText, 0, pageSize);
        }
    }, [searchText]);

    return (
        <Grid sx={{ marginTop: 4 }}>
            <Card >
                <CardHeader
                    titleTypographyProps={{ variant: "h6" }}
                    title={
                        <Grid container justifyContent="space-between" >
                            <Grid item>
                                <Typography variant="h6">
                                    Eccezioni
                                </Typography>
                            </Grid>
                            <Grid item>
                                <Button
                                    variant="contained"
                                    disableElevation
                                    color="info"
                                    disabled={disabled}
                                    onClick={addClickHandler}>
                                    Aggiungi
                                </Button>
                            </Grid>
                        </Grid>
                    }
                    sx={{ backgroundColor: "secondary.main", color: "white" }}
                />
                <Divider />
                <CardContent sx={{ padding: 0 }}>
                    <Table>
                        <TableHead sx={{ backgroundColor: "aliceblue", }}>
                            <TableRow>
                                <TableCell style={{ width: "60%" }}>NOME</TableCell>
                                <TableCell style={{ width: "10%" }}>
                                    Inizio validità
                                </TableCell>
                                <TableCell style={{ width: "10%" }}>
                                    Fine validità
                                </TableCell>
                                <TableCell style={{ width: "10%" }}>
                                    Inserito da
                                </TableCell>
                                <TableCell style={{ width: "10%" }}>
                                    Data inserimento
                                </TableCell>
                                <TableCell align="right"></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {eccezioni && eccezioni.result.length > 0
                                ? eccezioni.result.map((eccezione, index) => {
                                    return (
                                        <TableRow hover key={index}>
                                            <TableCell>
                                                <div sx={{
                                                    display: 'flex',
                                                    alignItems: 'center'
                                                }}>
                                                    <div>
                                                        {eccezione.ufficio.nome}
                                                    </div>
                                                </div>
                                            </TableCell>
                                            <TableCell>
                                                {eccezione.inizioValidita.toLocaleDateString("it-IT")}
                                            </TableCell>
                                            <TableCell>
                                                {eccezione.fineValidita
                                                    ? eccezione.fineValidita.toLocaleDateString(
                                                        "it-IT"
                                                    )
                                                    : '-'}
                                            </TableCell>
                                            <TableCell>
                                                <UtenteLink utenteId={eccezione?.creatoDa} />
                                            </TableCell>
                                            <TableCell>
                                                {stringToLocaleDateString(eccezione.dataCreazione)}
                                            </TableCell>
                                            <TableCell align="right">
                                                <IconButton
                                                    aria-label="delete"
                                                    disabled={disabled}
                                                    onClick={() => deleteClickHandler(eccezione)}>
                                                    <Tooltip title="elimina eccezione">
                                                        <DeleteIcon />
                                                    </Tooltip>
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })
                                :
                                <TableRow>
                                    <TableCell align="center" colSpan="100%" sx={{ padding: 8, color: "primary.main", fontWeight: "bold" }}>
                                        NON SONO PRESENTI ECCEZIONI
                                    </TableCell>
                                </TableRow>
                            }
                        </TableBody>
                    </Table>
                </CardContent>
                <TablePagination
                    component="div"
                    count={eccezioni ? eccezioni.totalCount : 0}
                    onPageChange={pageIndexChangeHandler}
                    page={pageIndex}
                    rowsPerPage={pageSize}
                    rowsPerPageOptions={[5, 10, 25]}
                />
            </Card>
        </Grid>
    );
}